module.exports = {
  "country": "BE",
  "artist": "Roberto Bellarosa",
  "song": "Love Kills",
  "year": "2013",
  "place": "12",
  "spotify": "0FyoA6hNmCcGN5JKx8Rddp"
};